// src/components/copilot/components/MessageBubble.jsx
import { Box, Paper } from "@mui/material";
import { blue, grey, green } from "@mui/material/colors";
import { memo } from "react";

const MessageBubble = memo(({ role, children, fullWidth = false }) => {
  const getBgColor = () => {
    if (role === "user") return blue[50];
    if (role === "system") return green[50];
    return "white";
  };

  const getBorderColor = () => {
    if (role === "user") return blue[100];
    if (role === "system") return green[200];
    return grey[300];
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        bgcolor: getBgColor(),
        border: `1px solid ${getBorderColor()}`,
        borderRadius: "16px",
        borderTopLeftRadius: role === "user" ? "16px" : "4px",
        borderTopRightRadius: role === "user" ? "4px" : "16px",
        width: fullWidth ? "100%" : "auto",
      }}
    >
      {children}
    </Paper>
  );
});

MessageBubble.displayName = "MessageBubble";

export default MessageBubble;
